import {EntityData, component} from "./entity.data";
import {LocalisableContextData} from "./localisable-context.data";

/**
 * Defines a localisable entity data
 */
export class LocalisableEntityData<T> extends EntityData<T> {
    @component localisableContext: LocalisableContextData = <LocalisableContextData>EntityData.createAsNode(LocalisableContextData, this);
    @component localisableChildContext: LocalisableContextData = <LocalisableContextData>EntityData.createAsNode(LocalisableContextData, this);

    /**
     * Is the specified field currently restricted given the localisation context of this localisable entity?
     * @return {boolean}
     * @param path
     */
    public isRestricted(path: string | symbol): boolean {
        return this.localisableContext.restricted && !this.isUnrestricted(path);
    }
}
